import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '..';
import {
  UpdateOrAddMeasurementsProps,
  GnssSettingsProps,
  UpdateCorrectionAngleProps,
  UpdateTpLocationProps,
  GnssEnableDisableProps,
  GnssFieldsProps,
} from 'models/gnssSettings';

export const GnssApi = createApi({
  reducerPath: 'GnssApi',
  tagTypes: ['gnss-settings', 'gnss-state', 'gnss-config-fields'],
  baseQuery,
  endpoints: (builder) => ({
    getGnssSettings: builder.query<GnssSettingsProps, string>({
      query: (url) => ({
        url: url,
      }),
      providesTags: ['gnss-settings'],
    }),
    addMeasurements: builder.mutation<void, UpdateOrAddMeasurementsProps>({
      query: ({ url, ...otherBodyprops }) => ({
        url: url,
        method: 'POST',
        body: otherBodyprops,
      }),
      invalidatesTags: ['gnss-settings'],
    }),

    updateCorrectionAngle: builder.mutation<void, UpdateCorrectionAngleProps>({
      query: ({ url, ...otherBodyprops }) => ({
        url: url,
        method: 'POST',
        body: otherBodyprops,
      }),
      invalidatesTags: ['gnss-settings'],
    }),

    updateTpLocationDegree: builder.mutation<void, UpdateTpLocationProps>({
      query: ({ url, ...otherBodyprops }) => ({
        url: url,
        method: 'POST',
        body: otherBodyprops,
      }),
      invalidatesTags: ['gnss-settings'],
    }),

    updateMeasrementTag: builder.mutation<void, UpdateOrAddMeasurementsProps>({
      query: ({ url, ...otherBodyprops }) => ({
        url: url,
        method: 'POST',
        body: otherBodyprops,
      }),
      invalidatesTags: ['gnss-settings'],
    }),

    getGnssState: builder.query<GnssEnableDisableProps, string>({
      query: (url) => ({
        url: url,
      }),
      providesTags: ['gnss-state'],
    }),

    updateGnssState: builder.mutation<void, string>({
      query: (url) => ({
        url: url,
        method: 'POST',
      }),
      invalidatesTags: ['gnss-state'],
    }),

    completeGnssSetup: builder.mutation<void, string>({
      query: (url) => ({
        url: url,
        method: 'POST',
        body: {
          complete: true,
        },
      }),
      invalidatesTags: ['gnss-state', 'gnss-settings'],
    }),
    getGnssSettingConfigFields: builder.query<GnssFieldsProps, string>({
      query: (url) => ({
        url: url,
      }),
      providesTags: ['gnss-config-fields'],
    }),

    updateGnssConfigFields: builder.mutation<
      void,
      GnssFieldsProps['wizard_config'] & {
        url: string;
      }
    >({
      query: ({ url, ...body }) => ({
        url: url,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['gnss-config-fields', 'gnss-state', 'gnss-settings'],
    }),
  }),
});

export const {
  useGetGnssSettingsQuery,
  useAddMeasurementsMutation,
  useUpdateCorrectionAngleMutation,
  useUpdateTpLocationDegreeMutation,
  useUpdateMeasrementTagMutation,
  useGetGnssStateQuery,
  useUpdateGnssStateMutation,
  useCompleteGnssSetupMutation,
  useGetGnssSettingConfigFieldsQuery,
  useUpdateGnssConfigFieldsMutation,
} = GnssApi;
